exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".r-fonteva-icon {\r\n  fill: transparent;\r\n}\r\n\r\n.r-fonteva-icon-letter {\r\n  fill: transparent;\r\n}", ""]);
